export function yClamp(n: number, a: number, b: number) {
    return n <= a ? a : n >= b ? b : n;
}

export function yBisect<T>(array: T[], x: number, f: (v: T) => number): number {
    let lo = 0, hi = array.length;
    while(lo < hi) {
        const mid = (lo + hi) >>> 1;
        if(f(array[mid]) > x)
            hi = mid
        else
            lo = mid + 1
    }

    return lo;
}

export function yMax<T, U>(array: T[], f: (v: T) => U): U | undefined
export function yMax<T>(array: T[]): T | undefined
export function yMax(array: number[], f?: (v: number) => number): number | undefined {
    let i = -1;
    let n = array.length;
    let a: number | undefined;
    let b: number | undefined;

    if(f) {
        while(++i < n) {
            if((b = f(array[i])) != undefined && b <= b) {
                a = b;
                break;
            }
        }
        while(++i < n) {
            if((b = f(array[i])) != undefined && a! < b)
                a = b;
        }
    } else {
        while(++i < n) {
            if((b = array[i]) != undefined && b <= b) {
                a = b;
                break;
            }
        }
        while(++i < n) {
            if((b = array[i]) != undefined && a! < b)
                a = b;
        }
    }

    return a;
}

export function yMin<T, U>(array: T[], f: (v: T) => U): U | undefined
export function yMin<T>(array: T[]): T | undefined
export function yMin(array: number[], f?: (v: number) => number): number | undefined {
    let i = -1;
    let n = array.length;
    let a: number | undefined;
    let b: number | undefined;

    if(f) {
        while(++i < n) {
            if((b = f(array[i])) != undefined && b <= b) {
                a = b;
                break;
            }
        }
        while(++i < n) {
            if((b = f(array[i])) != undefined && b < a!)
                a = b;
        }
    } else {
        while(++i < n) {
            if((b = array[i]) != undefined && b <= b) {
                a = b;
                break;
            }
        }
        while(++i < n) {
            if((b = array[i]) != undefined && b < a!)
                a = b;
        }
    }

    return a;
}
